// Modelo Compañia para administrador.
export default class Activity {
    id = ""
    activity = ""
    name = ""
    description = ""
    host = ""
    topic = ""
    file = ""
    filePath = ""
    fileName = ""
    fileType = ""
    date = ""
    company = ""
    status = ""
    date = ""
    asistants = ""
    note = ""
    comments = ""
    anexos = []
    conclusion = ""
    questions = ""
}



// WEBPACK FOOTER //
// ./src/model/Activity.js